(function ($) {
    'use strict'

    var activeModal = null

    function event(name, element) {
        var result = $.Event(name)
        $(element).trigger(result)
        return result
    }

    function targetFromTrigger(trigger) {
        var selector = trigger.attr('data-target') || trigger.attr('href')
        if (!selector || selector === '#') return $()
        selector = selector.split('?')[0]
        return $(selector)
    }

    function Modal(element) {
        this.element = element
        this.$element = $(element)
        this.$backdrop = null
    }

    Modal.prototype.show = function () {
        var self = this
        if (activeModal && activeModal !== this) activeModal.hide()
        if (event('show.bs.modal', this.element).isDefaultPrevented()) return

        activeModal = this
        this.$element.show().scrollTop(0).addClass('in')
        $('body').addClass('modal-open')
        this.$backdrop = $('<div class="modal-backdrop fade in"></div>').appendTo(document.body)
        this.$backdrop.on('click', function () {
            if (self.$element.data('backdrop') !== 'static') self.hide()
        })
        this.$element.attr('aria-hidden', 'false')
        event('shown.bs.modal', this.element)
    }

    Modal.prototype.hide = function () {
        if (event('hide.bs.modal', this.element).isDefaultPrevented()) return
        this.$element.removeClass('in').hide().attr('aria-hidden', 'true')
        if (this.$backdrop) this.$backdrop.remove()
        this.$backdrop = null
        $('body').removeClass('modal-open')
        if (activeModal === this) activeModal = null
        event('hidden.bs.modal', this.element)
    }

    Modal.prototype.toggle = function () {
        if (this.$element.hasClass('in')) this.hide()
        else this.show()
    }

    function plugin(name, Constructor, defaultMethod) {
        $.fn[name] = function (option) {
            var args = Array.prototype.slice.call(arguments, 1)
            return this.each(function () {
                var instance = $.data(this, 'bootstrap-shim-' + name)
                if (!instance) {
                    instance = new Constructor(this, typeof option === 'object' ? option : {})
                    $.data(this, 'bootstrap-shim-' + name, instance)
                }
                if (typeof option === 'string' && typeof instance[option] === 'function') {
                    instance[option].apply(instance, args)
                } else if (typeof option !== 'string' && defaultMethod) {
                    instance[defaultMethod]()
                }
            })
        }
    }

    function Collapse(element) {
        this.element = element
        this.$element = $(element)
    }

    Collapse.prototype.show = function () {
        if (this.$element.hasClass('in')) return
        if (event('show.bs.collapse', this.element).isDefaultPrevented()) return
        var parent = this.$element.attr('data-parent') || $('[data-toggle="collapse"][href="#' + this.element.id + '"], [data-toggle="collapse"][data-target="#' + this.element.id + '"]').attr('data-parent')
        if (parent) $(parent).find('.collapse.in').not(this.$element).collapse('hide')
        this.$element.removeClass('collapse').addClass('collapsing').show()
        this.$element.removeClass('collapsing').addClass('collapse in')
        event('shown.bs.collapse', this.element)
    }

    Collapse.prototype.hide = function () {
        if (!this.$element.hasClass('in')) return
        if (event('hide.bs.collapse', this.element).isDefaultPrevented()) return
        this.$element.removeClass('in')
        event('hidden.bs.collapse', this.element)
    }

    Collapse.prototype.toggle = function () {
        if (this.$element.hasClass('in')) this.hide()
        else this.show()
    }

    function Floating(element, options, type) {
        this.element = element
        this.$element = $(element)
        this.options = $.extend({}, this.$element.data(), options || {})
        this.type = type
        this.$tip = null
        this.bind()
    }

    Floating.prototype.triggers = function () {
        if (this.options.trigger) return this.options.trigger
        return this.type === 'popover' ? 'click' : 'hover focus'
    }

    Floating.prototype.bind = function () {
        var self = this
        var triggers = this.triggers()
        if (/hover/.test(triggers)) {
            this.$element.on('mouseenter.bs.' + this.type, function () { self.show() })
            this.$element.on('mouseleave.bs.' + this.type, function () { self.hide() })
        }
        if (/focus/.test(triggers)) {
            this.$element.on('focusin.bs.' + this.type, function () { self.show() })
            this.$element.on('focusout.bs.' + this.type, function () { self.hide() })
        }
        if (/click/.test(triggers)) this.$element.on('click.bs.' + this.type, function (e) {
            e.preventDefault()
            self.toggle()
        })
    }

    Floating.prototype.show = function () {
        if (this.$tip) return
        if (this.$element.attr('title')) this.$element.attr('data-original-title', this.$element.attr('title')).removeAttr('title')
        var title = this.options.title || this.$element.attr('data-original-title')
        var content = this.type === 'popover' ? (this.options.content || this.$element.attr('data-content')) : title
        if (!content) return
        if (event('show.bs.' + this.type, this.element).isDefaultPrevented()) return
        var placement = this.options.placement || 'top'
        var method = this.options.html ? 'html' : 'text'
        if (this.type === 'popover') {
            this.$tip = $('<div class="popover ' + placement + ' in" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>')
            this.$tip.find('.popover-content')[method](content)
            if (title) this.$tip.find('.popover-title')[method](title)
            else this.$tip.find('.popover-title').hide()
        } else {
            this.$tip = $('<div class="tooltip ' + placement + ' in" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>')
            this.$tip.find('.tooltip-inner')[method](content)
        }
        var container = this.options.container ? $(this.options.container) : $()
        this.$tip.appendTo(container.length ? container.first() : document.body).css('display', 'block')
        var offset = this.$element.offset()
        var width = this.$element.outerWidth()
        var height = this.$element.outerHeight()
        var tipWidth = this.$tip.outerWidth()
        var tipHeight = this.$tip.outerHeight()
        var coords
        if (placement === 'bottom') coords = {top: offset.top + height, left: offset.left + width / 2 - tipWidth / 2}
        else if (placement === 'left') coords = {top: offset.top + height / 2 - tipHeight / 2, left: offset.left - tipWidth}
        else if (placement === 'right') coords = {top: offset.top + height / 2 - tipHeight / 2, left: offset.left + width}
        else coords = {top: offset.top - tipHeight, left: offset.left + width / 2 - tipWidth / 2}
        this.$tip.css(coords)
        event('shown.bs.' + this.type, this.element)
    }

    Floating.prototype.hide = function () {
        if (!this.$tip) return
        if (event('hide.bs.' + this.type, this.element).isDefaultPrevented()) return
        this.$tip.remove()
        this.$tip = null
        event('hidden.bs.' + this.type, this.element)
    }

    Floating.prototype.toggle = function () {
        if (this.$tip) this.hide()
        else this.show()
    }

    Floating.prototype.destroy = function () {
        this.hide()
        this.$element.off('.bs.' + this.type)
        this.$element.removeData('bootstrap-shim-' + this.type)
    }

    plugin('modal', Modal, 'show')
    plugin('collapse', Collapse)
    plugin('tooltip', function (element, options) { return new Floating(element, options, 'tooltip') })
    plugin('popover', function (element, options) { return new Floating(element, options, 'popover') })

    $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
        e.preventDefault()
        targetFromTrigger($(this)).modal('show')
    })
    $(document).on('click.bs.modal.data-api', '[data-dismiss="modal"]', function (e) {
        e.preventDefault()
        $(this).closest('.modal').modal('hide')
    })
    $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
        e.preventDefault()
        var trigger = $(this)
        targetFromTrigger(trigger).collapse('toggle')
        trigger.toggleClass('collapsed').attr('aria-expanded', targetFromTrigger(trigger).hasClass('in') ? 'true' : 'false')
    })
    $(document).on('click.bs.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]', function (e) {
        e.preventDefault()
        var trigger = $(this)
        var target = targetFromTrigger(trigger)
        if (!target.length || trigger.closest('li').hasClass('active')) return
        var nav = trigger.closest('ul')
        var previous = nav.find('.active > a').get(0)
        if (event('show.bs.tab', this).isDefaultPrevented()) return
        nav.find('li.active').removeClass('active')
        trigger.closest('li').addClass('active')
        target.closest('.tab-content').children('.tab-pane').removeClass('active in')
        target.addClass('active in')
        var shown = $.Event('shown.bs.tab', {relatedTarget: previous})
        trigger.trigger(shown)
    })
    $(document).on('click.bs.dropdown.data-api', '[data-toggle="dropdown"]', function (e) {
        e.preventDefault()
        e.stopPropagation()
        var parent = $(this).parent()
        var isOpen = parent.hasClass('open')
        $('.dropdown.open').removeClass('open')
        if (!isOpen) parent.addClass('open')
        parent.find('.dropdown-menu').first().attr('aria-hidden', parent.hasClass('open') ? 'false' : 'true')
    })
    $(document).on('click.bs.dropdown.data-api', function (e) {
        if (/input|textarea/i.test(e.target.tagName) && $(e.target).closest('.dropdown.open').length) return
        $('.dropdown.open').removeClass('open')
    })
    function carouselSlide($carousel, dir) {
        var $items = $carousel.find('.carousel-inner > .item')
        if ($items.length < 2) return
        var idx = $items.index($items.filter('.active'))
        var next
        if (dir === 'prev') next = idx <= 0 ? $items.length - 1 : idx - 1
        else if (dir === 'next') next = idx >= $items.length - 1 ? 0 : idx + 1
        else next = dir
        if (next === idx || next < 0 || next >= $items.length) return
        if (event('slide.bs.carousel', $carousel[0]).isDefaultPrevented()) return
        $items.removeClass('active')
        $items.eq(next).addClass('active')
        $carousel.find('.carousel-indicators > *').removeClass('active').eq(next).addClass('active')
        event('slid.bs.carousel', $carousel[0])
    }

    // Auto-cycling is intentionally not implemented; the only carousel in the app is a
    // document viewer where manual prev/next is the desired behaviour.
    $.fn.carousel = function (option) {
        return this.each(function () {
            if (option === 'next' || option === 'prev' || typeof option === 'number') carouselSlide($(this), option)
        })
    }

    $(document).on('click.bs.carousel.data-api', '[data-slide], [data-slide-to]', function (e) {
        e.preventDefault()
        var trigger = $(this)
        var $carousel = targetFromTrigger(trigger)
        if (!$carousel.length) $carousel = trigger.closest('.carousel')
        if (!$carousel.length) return
        var slideTo = trigger.attr('data-slide-to')
        if (slideTo != null && slideTo !== '') carouselSlide($carousel, parseInt(slideTo, 10))
        else carouselSlide($carousel, trigger.attr('data-slide'))
    })

    $(document).on('keydown.bs.modal', function (e) {
        if (e.keyCode === 27 && activeModal) activeModal.hide()
    })
})(window.jQuery)
